export default __webpack_public_path__ + "static/media/language-ro.b73cfaf5.svg";